{
  "metadata": {
    "id": "synthwave84-light",
    "name": "Synthwave '84",
    "description": "Портировано из темы «Synthwave '84» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "synthwave84.json",
      "project": "robb0wen",
      "url": "https://github.com/robb0wen/synthwave-vscode",
      "upstreamFile": "packages/ui/src/theme/themes/synthwave84.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.9,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.537,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 30.7,
      "syntaxVsTextMinDeltaE": 25.1,
      "chartsMinDeltaE": 24.1,
      "textSeparationDeltaE": 18.6,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "number",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#009cb0",
      "hover": "#008c9e",
      "active": "#008090",
      "foreground": "#000000",
      "muted": "#009cb080",
      "emphasis": "#009cb0"
    },
    "surface": {
      "background": "#fafafa",
      "foreground": "#262335",
      "muted": "#cdccd1",
      "mutedForeground": "#454568",
      "elevated": "#b6b6bc",
      "elevatedForeground": "#262335",
      "raised": "#9c9ba4",
      "raisedForeground": "#262335",
      "overlay": "#fafafa33",
      "subtle": "#e4e3e6"
    },
    "interactive": {
      "border": "#94939d",
      "borderHover": "#bfbec3",
      "borderFocus": "#009cb0",
      "selection": "#26233524",
      "selectionForeground": "#262335",
      "focus": "#009cb059",
      "focusRing": "#009cb047",
      "cursor": "#262335",
      "hover": "#26233517",
      "active": "#26233524"
    },
    "status": {
      "error": "#e11b0c",
      "errorForeground": "#ffffff",
      "errorBackground": "#e11b0c1a",
      "errorBorder": "#e11b0c59",
      "warning": "#a36100",
      "warningForeground": "#ffffff",
      "warningBackground": "#a361001a",
      "warningBorder": "#a3610059",
      "success": "#38813b",
      "successForeground": "#ffffff",
      "successBackground": "#38813b1a",
      "successBorder": "#38813b59",
      "info": "#d43300",
      "infoForeground": "#ffffff",
      "infoBackground": "#d433001a",
      "infoBorder": "#d4330059"
    },
    "pr": {
      "open": "#38813b",
      "draft": "#52527b",
      "blocked": "#a36100",
      "merged": "#9c27b0",
      "closed": "#e11b0c"
    },
    "syntax": {
      "base": {
        "background": "#cdccd1",
        "foreground": "#262335",
        "comment": "#52527b",
        "keyword": "#aa1145",
        "string": "#7a4900",
        "number": "#8d239f",
        "function": "#8d239f",
        "variable": "#262335",
        "type": "#005d69",
        "operator": "#aa1145"
      },
      "tokens": {
        "commentDoc": "#52527b",
        "stringEscape": "#aa1145",
        "keywordImport": "#aa1145",
        "storageModifier": "#aa1145",
        "functionCall": "#8d239f",
        "method": "#8d239f",
        "variableProperty": "#8d239f",
        "variableOther": "#262335",
        "variableGlobal": "#8d239f",
        "variableLocal": "#aa1145",
        "parameter": "#262335",
        "constant": "#8d239f",
        "class": "#005d69",
        "className": "#005d69",
        "interface": "#005d69",
        "struct": "#005d69",
        "enum": "#005d69",
        "typeParameter": "#005d69",
        "namespace": "#005d69",
        "module": "#aa1145",
        "tag": "#aa1145",
        "jsxTag": "#aa1145",
        "tagAttribute": "#8d239f",
        "tagAttributeValue": "#7a4900",
        "boolean": "#8d239f",
        "decorator": "#aa1145",
        "label": "#8d239f",
        "regexp": "#7a4900"
      }
    },
    "charts": {
      "series": [
        "#009cb0",
        "#d43300",
        "#38813b",
        "#a36100",
        "#f37723"
      ]
    },
    "chat": {
      "background": "#fafafa",
      "userMessage": "#262335",
      "userMessageBackground": "#b6b6bc",
      "assistantMessage": "#262335",
      "assistantMessageBackground": "#cdccd1",
      "timestamp": "#52527b",
      "divider": "#94939d",
      "typing": "#52527b"
    },
    "loading": {
      "spinner": "#009cb0",
      "spinnerTrack": "#cdccd1",
      "skeleton": "#cdccd1",
      "shimmer": "#c3c2c8"
    },
    "tools": {
      "background": "#cdccd1",
      "border": "#94939d",
      "headerHover": "#c5c4c9",
      "icon": "#007c8c",
      "title": "#262335",
      "description": "#52527b",
      "edit": {
        "added": "#38813b",
        "addedBackground": "#38813b1a",
        "removed": "#e11b0c",
        "removedBackground": "#e11b0c1a",
        "modified": "#d43300",
        "modifiedBackground": "#d433001a",
        "lineNumber": "#52527b"
      }
    },
    "markdown": {
      "heading1": "#262335",
      "heading2": "#262335",
      "heading3": "#262335",
      "heading4": "#262335",
      "link": "#007c8c",
      "linkHover": "#007e8f",
      "inlineCode": "#7a4900",
      "inlineCodeBackground": "#cdccd1",
      "blockquote": "#52527b",
      "blockquoteBorder": "#94939d",
      "listMarker": "#0097ab",
      "bold": "#262335",
      "italic": "#262335e6",
      "strikethrough": "#52527b",
      "hr": "#94939d"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b6423e",
        "foreground": "#ffffff",
        "contrast": 5.47
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#8b573b",
        "foreground": "#ffffff",
        "contrast": 5.96
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cda067",
        "foreground": "#000000",
        "contrast": 8.82
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#cad26e",
        "foreground": "#000000",
        "contrast": 12.96
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718f42",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#50bc4c",
        "foreground": "#000000",
        "contrast": 8.64
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6dcf90",
        "foreground": "#000000",
        "contrast": 10.98
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e71",
        "foreground": "#000000",
        "contrast": 5.35
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bc2ce",
        "foreground": "#000000",
        "contrast": 10.23
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3e758c",
        "foreground": "#ffffff",
        "contrast": 5.09
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#365088",
        "foreground": "#ffffff",
        "contrast": 7.9
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#353db0",
        "foreground": "#ffffff",
        "contrast": 8.59
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8866be",
        "foreground": "#000000",
        "contrast": 4.69
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b746b4",
        "foreground": "#ffffff",
        "contrast": 4.62
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b79",
        "foreground": "#ffffff",
        "contrast": 7.04
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c16882",
        "foreground": "#000000",
        "contrast": 5.57
      }
    ]
  }
}
